export default __webpack_public_path__ + "static/media/liveTraffic_Yay.02403442.svg";